import {Directive, ElementRef, OnInit} from "@angular/core";

@Directive({
  selector: '[nw-button-toggle-primary]'
})
export class NewellMatButtonTogglePrimaryDirective implements OnInit {

  private readonly className: string = 'mat-button-toggle-group-primary';
  constructor(private _el: ElementRef) {}

  ngOnInit() {
    this._el.nativeElement.classList.add(this.className);
  }
}
